<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6673 7.33337V11.3334C14.6673 14 14.0007 14.6667 11.334 14.6667H4.66732C2.00065 14.6667 1.33398 14 1.33398 11.3334V4.66671C1.33398 2.00004 2.00065 1.33337 4.66732 1.33337H5.66732C6.66732 1.33337 6.88732 1.62671 7.26732 2.13337L8.26732 3.46671C8.52065 3.80004 8.66732 4.00004 9.33398 4.00004H11.334C14.0007 4.00004 14.6673 4.66671 14.6673 7.33337Z"
      stroke="#A2A5B9"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script>
export default {
  name: "FolderIcon",
};
</script>
